/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExternalEhrType = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH'
} as const;
export type ExternalEhrType = typeof ExternalEhrType[keyof typeof ExternalEhrType];


export function ExternalEhrTypeFromJSON(json: any): ExternalEhrType {
    return ExternalEhrTypeFromJSONTyped(json, false);
}

export function ExternalEhrTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrType {
    return json as ExternalEhrType;
}

export function ExternalEhrTypeToJSON(value?: ExternalEhrType | null): any {
    return value as any;
}

